module.exports = __webpack_public_path__ + "_assets/img/document.976e7a7c.svg";